import React from 'react';
import { PlainPageHeadingContext } from 'components/plain_page_heading';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import Link from 'components/link';
import Text from 'components/text';

export const FaqRowGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

const Row = styled.div`
  background: #FFF;
  padding: ${props => props.embedded ? '20px 20px 20px 0' : '20px'};
  height: 100%;
  display: flex;
  align-items: center;
  &:hover {
    background: whitesmoke;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 5px;
`;

const IconWrapper = styled.div`
  width: 70px;
`;

const IconCircle = styled.div`
  height: 50px;
  width: 50px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.background};
  color: ${props => props.color};
  svg {
    fill: ${props => props.color};
    width: 24px;
  }
  svg [stroke]:not([stroke="none"]) {
    stroke: ${props => props.color};
  }
  .pencil-with-circle-icon {
    stroke: ${props => props.color};
  }
  .fa {
    color: ${props => props.color};
  }
  .bookmark-icon, .japanese-character-icon {
    svg {
      width: 20px;
    }
  }
`;

@observer
class FaqRow extends React.Component {
  static contextType = PlainPageHeadingContext;

  render() {
    const { to, icon, title, description, mutedText, iconBackground = '#e8e8e8', iconColor = '#333' } = this.props;
    return (
      <Link to={to}>
        <Row embedded={this.context}>
          <IconWrapper>
            <IconCircle
              background={iconBackground}
              color={iconColor}
            >
              {icon}
            </IconCircle>
          </IconWrapper>
          <TextWrapper>
            <Text
              fontSize='18px'
              bold
              color='#333'
            >
              {title}
            </Text>
            <Text
              fontSize='14px'
              color='#333'
            >
              {description}
            </Text>
            {
              mutedText &&
              <Text
                fontSize='12px'
                color='#999'
              >
                {mutedText}
              </Text>
            }
          </TextWrapper>
        </Row>
      </Link>
    );
  }
}

export default FaqRow;
